<div class="rules-section">
  <div class="flex flex-horiz-space-bw m-t-b-10 p-b-10">

    <div class="grid grid-3x grid-gap-10" style="width: 594px">

      <!-- Filters -->
      <!-- <div>
        <nz-radio-group [(ngModel)]="rulesRadio" [nzButtonStyle]="'solid'" style="width: 100%" (ngModelChange)="filterRules(rulesRadio)">
          <label nz-radio-button nzValue="Rejected">Failed</label>
          <label nz-radio-button nzValue="APPROVE">Passed</label>
        </nz-radio-group> 
      </div> -->

      <!-- Categories -->
      <div *ngIf="enableCategories" class="text-a-right">
        <!-- IMP: FILTERING OF CATEGORIES CODE NOT DONE ON baseUI -- MUST WRITE THIS DURING DEV. -->
        <nz-select [ngModel]="'All Categories'" style="width: 100%" nzSize="default">
          <nz-option [nzLabel]="'All Categories'" [nzValue]="'All Categories'"></nz-option>
          <nz-option [nzLabel]="'Waiting Period'" [nzValue]="'Waiting Period'"></nz-option>
          <nz-option [nzLabel]="'Adjudication'" [nzValue]="'Adjudication'"></nz-option>
          <nz-option [nzLabel]="'Eligibility/Validation'" [nzValue]="'Eligibility/Validation'"></nz-option>
        </nz-select>
      </div>

      <!-- FRAUD CASE -->
      <!-- IMP: FILTERING OF CATEGORIES CODE NOT DONE ON baseUI -- MUST WRITE THIS DURING DEV. -->
      <div *ngIf="type==='fraud'" class="text-a-right">
        <nz-select [ngModel]="'Fraud, Waste & Abuse'" style="width: 100%;" nzSize="default">
          <nz-option [nzLabel]="'Fraud, Waste & Abuse'" [nzValue]="'Fraud, Waste & Abuse'" (click)="filterRules('All')"></nz-option>
          <nz-option [nzLabel]="'Fraud'" [nzValue]="'Fraud'" (click)="filterRules('All')"></nz-option>
          <nz-option [nzLabel]="'Waste'" [nzValue]="'Waste'" (click)="filterRules('All')"></nz-option>
          <nz-option [nzLabel]="'Abuse'" [nzValue]="'Abuse'" (click)="filterRules('All')"></nz-option>
        </nz-select>
      </div>

      <!-- Search -->
      <div>
        <nz-input-group [nzSuffix]="suffixIconSearch" style="width: 100%">
          <input type="text" nz-input placeholder="Filter rules" [(ngModel)]="fileteRuleName" />
        </nz-input-group>
        <ng-template #suffixIconSearch>
         <em nz-icon nzType="search"></em>
        </ng-template>
      </div>

    </div>

    <div class="f-s-1-3r p-r-5">
      <!-- <span  class="clickable" (click)="filterRules('All')">Total {{rulesData.length}} rules </span> &bull;&nbsp; -->
      <span class="col-red clickable" (click)="filterRules('Rejected')"><!--{{rulesFailedCount}}-->(2) Reject</span> &bull;&nbsp;
      <span class="col-green clickable" (click)="filterRules('APPROVE')"><!--{{rulesPassedCount}} -->(1) Accept</span> &bull;&nbsp;
      <span class="col-black clickable" (click)="filterRules('REFER')"><!--{{rulesPassedCount}} -->(1) Refer</span>
    </div>

  </div>

  <!-- {{rulesRadio.toString().toLowerCase()}}  -->
  <div class="heading-tab">
    <h3 class="heading d-b m-t-b-20"><em nz-icon nzType="profile"></em> Showing 
        <Span *ngIf="rulesRadio=='Rejected'">Failed</Span>
        <Span *ngIf="rulesRadio=='APPROVE'">Passed</Span>
        rules (4)<!-- {{rulesDataFiltered.length}}--></h3> 
        <!-- {{rulesDataFiltered}} -->
  </div>

  <nz-skeleton [nzAvatar]="false" [nzActive]="true" [nzTitle]="true" [nzLoading]="rulesLoading">

    <!-- TABLE FOR UW and CLAIMS -->
    <nz-table [nzData]="[1,2,3]" [nzShowPagination]="false" [nzScroll]="{x:'1100px'}" *ngIf="type!=='fraud'">
      <thead class="table-header">
      <tr>
        <th scope="col">Rule Name</th>
        <th scope="col">Rule Sub-type</th>
        <th scope="col">Decision Type</th>
        <th scope="col">Decision</th>
        <th scope="col">Decision Value</th>
        <th scope="col">Weight</th>
        <th scope="col">Recommendation</th>
      </tr>
      </thead>
      <tbody>
      <!-- Without Categories (old code) -->
      <ng-container *ngIf="!enableCategories">
        <tr class="table-row" *ngFor="let rule of rulesDataFiltered">
          <td *ngIf="rulesRadio=='Rejected'"><Span class="col-red">{{rule.name}}</Span></td>
          <td *ngIf="rulesRadio=='APPROVE'"><Span class="col-green">{{rule.name}}</Span></td>
          <td>{{rule?.ruleSubType}}</td>
          <td>{{rule.decisionType}}</td>
          <td>{{rule.decision}}</td>
          <td>{{rule.decisionVal}}</td>
          <td>{{rule.weight}}</td>
          <td>{{rule.recco}}</td>
        </tr>
      </ng-container>

      <!-- WITH CATEGORIES -->
      <ng-container *ngIf="enableCategories">
        <ng-container *ngFor="let c of rulesDataCategorized  | keyvalue">
          <tr style="background-color: #f0f8ff">
            <td colspan="21"><h5 class="m-0 p-0">{{c.key}}</h5></td>
          </tr>
          <tr class="table-row" *ngFor="let rule of c.value">
            <td><span class="p-l-10 d-i-b">{{rule.name}}</span></td>
            <!--<td><span class="p-l-10 d-i-b">{{rule.ruleSubType}}</span></td>-->
            <td><span class="p-l-10 d-i-b">{{rule.decisionType}}</span></td>
            <td><span class="p-l-10 d-i-b">{{rule.decision}}</span></td>
            <td><span class="p-l-10 d-i-b">{{rule.decisionVal}}</span></td>
            <td><span class="p-l-10 d-i-b">{{rule.weight}}</span></td>
            <td><span class="p-l-10 d-i-b">{{rule.recco}}</span></td>
          </tr>
        </ng-container>
      </ng-container>

      </tbody>
    </nz-table>

    <!-- FRAUD RULES TABLE -->
    
    <nz-table [nzData]="[1,2,3]" [nzShowPagination]="false" [nzScroll]="{}" *ngIf="type=='fraud'">
      <thead class="table-header">
      <tr>
        <th scope="col" nzCustomFilter>Rule Name
          <nz-filter-trigger [nzDropdownMenu]="menu">
            <i nz-icon nzType="search"></i>
          </nz-filter-trigger>
         <!-- <em nz-th-extra class="ant-table-filter-icon" nz-icon nz-dropdown #dropdown="nzDropdown"
          nzType="search" [nzDropdownMenu]="menu" [class.ant-table-filter-open]="dropdown.nzVisible"
          nzTrigger="click" nzPlacement="bottomRight" [nzClickHide]="false" nzTableFilter></em> -->
        </th>
        <th scope="col" class="" nzShowFilter [nzFilters]="listOfCategories"
        (nzFilterChange)="filterRulesOnCategory($event)">Rule Message</th>
        <th scope="col">Rule Decision</th>

        <!-- <th scope="col" class="" nzShowFilter [nzFilters]="listOfCategories"
        (nzFilterChange)="filterRulesOnCategory($event)">Cluster</th>
        <th scope="col">Weightage</th> -->
        <ng-container *ngIf="transactionState=='claimInvestigation'">
          <th scope="col">Investigation Finding</th>
          <th scope="col">Investigator Remarks</th>
        </ng-container>
        <ng-container *ngIf="fraudUserType=='adjudicator-post-investigation'">
          <th scope="col">Investigation Finding</th>
          <th scope="col">Investigator Remarks</th>
        </ng-container>
      </tr>
      </thead>
      <tbody>
        <tr>
          <td>Blacklisted Insured</td>
          <td>Insured Aman Kumar found in blacklisted client list</td>
          <td>Reject</td>
        </tr>
        <tr>
          <td>Pin code red flag</td>
          <td>Pin code found in red flag area</td>
          <td>Reject</td>
        </tr>
        <tr>
          <td>Blacklisted Insured</td>
          <td>Insured Nayan Patil not from blacklisted client list</td>
          <td>Accept</td>
        </tr>
        <tr>
          <td>Lapsed Ratio</td>
          <td>Lapsed ratio is high for the policies submitted by the Agent</td>
          <td>Refer</td>
        </tr>
      </tbody>
      <!-- <tbody>
        <tr class="table-row" *ngFor="let rule of rulesDataFiltered | filter:fileteRuleName">
          <td style="min-width: 525px">
            {{(rule.name || rule.ruleName) || "-"}}
            <span class="col-grey-light" nz-popover [nzPopoverTitle]="rule.category||'Info.'" [nzPopoverContent]="rule.scenario||rule.validation" nzPopoverPlacement="right">
             <em nz-icon nzType="info-circle" class="col-grey-light"></em>
            </span>
          </td>
          <td>{{(rule.ruleCategory| technicalTranslate)}}</td>
          <td>{{(rule?.ruleSubType| technicalTranslate)}}</td>

          
          <ng-container *ngIf="transactionState=='claimInvestigation'">
            <td>
              <nz-select [(ngModel)]="rule.invStatus" nzAllowClear nzPlaceHolder="Select" style="width:150px">
                <nz-option nzValue="fraud" nzLabel="Fraud"></nz-option>
                <nz-option nzValue="non-fraud" nzLabel="Non-Fraud"></nz-option>
                <nz-option nzValue="pending" nzLabel="Pending Investigation"></nz-option>
                <nz-option nzValue="na" nzLabel="Not Applicable"></nz-option>
              </nz-select>
            </td>
            <td>
              <span>
                <textarea rows="1" nz-input [(ngModel)]="rule.invRemarks" [nzAutosize]="true"></textarea>
              </span>
            </td>
          </ng-container>

          <ng-container *ngIf="fraudUserType=='adjudicator-post-investigation'">
            <td>
              <span *ngIf="rule.invStatus=='fraud'" class="col-red">Verified as Fraud</span>
              <span *ngIf="rule.invStatus=='non-fraud'" class="col-green-darker">Verified as Non-fraud</span>
              <span *ngIf="rule.invStatus=='pending'" class="col-grey-light">-</span>
              <span *ngIf="rule.invStatus=='na'" class="col-grey-light" style="font-style: italic">Not Applicable</span>
            </td>
            <td>
              <span>{{rule.invRemarks}}</span>
            </td>
          </ng-container>

        </tr>
      </tbody> -->
    </nz-table>


    <nz-dropdown-menu #menu="nzDropdownMenu">
      <div class="search-box">
        <input type="text" nz-input placeholder="Search Rule" [(ngModel)]="searchValue" />
        <button nz-button nzSize="small" nzType="primary" (click)="searchRules(searchValue)"
          class="search-button">
          Search
        </button>
        <button nz-button nzSize="small" (click)="reset()">Reset</button>
      </div>
    </nz-dropdown-menu>

  </nz-skeleton>
</div>
